<template>
  <div class="recorder" ref="comRecoder">
    <!-- 待录音状态 -->
    <img
      class="microphone-img"
      src="@/assets/images/hsk/microphone.png"
      @click="manualStart"
      v-if="isExamMode && !startRecord"
      :style="{ cursor: manualRecord ? 'pointer' : 'not-allowed' }"
    />

    <!-- 录音状态 -->
    <div v-else-if="isExamMode && startRecord" class="wave-con">
      <ul class="wave" ref="wave" style="width: 200px; height: 100px" @click="end">
        <li v-for="(item, index) in points" :style="{ height: item + '%' }" :key="index"></li>
      </ul>
      <p v-if="tip" class="tip">{{ $t('hsk_is_recording') }} {{ duration }} / {{ limitTime }}</p>
    </div>
    <p v-if="manualRecord && !startRecord">{{ $t('start_recording') }}</p>
    <!-- 播放状态 -->
    <!-- <button @click="start">start</button> -->
    <!-- <button @click="end">end</button> -->
  </div>
</template>

<script>
/* eslint-disable */
// 取样, 从数组中取出num个数
function exmples(arr, num) {
  const len = arr.length
  const step = Math.floor(len / num)
  const res = []
  for (let i = 0; i < num; i++) {
    res.push(arr[i * step])
  }
  return res
}
// 格式化时间
function formatTime(time) {
  time = parseInt(time)
  let min = Math.floor(time / 60)

  const sec = time % 60
  if (min < 10) {
    min = '0' + min
  }
  return `${min}:${sec < 10 ? '0' + sec : sec}`
}
// 点的个数
const pointNum = 20
import Recorder from './recorder.js'
import { lamejs } from './lame.js'
import { mapState } from 'vuex'
export default {
  props: {
    time: {
      type: Number || String,
      default: 0,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    manualRecord: {
      type: Boolean,
      default: false,
    },
    // deviceId: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      points: Array.from({ length: pointNum }, () => {
        return 5
      }),
      recorder: null,
      duration: '00:00',
      tip: '',
      remain: 0,
      startRecord: false,
      limitTime: '',
      timeoutId: '',
    }
  },
  computed: {
    ...mapState({
      inputDeviceId: (state) => state.simulation.inputDeviceId,
    }),
  },
  mounted() {
    this.limitTime = formatTime(this.time)

    const recorder = (this.recorder = new Recorder({
      sampleBits: 16,
      sampleRate: 16000,
      numChannels: 1,
      compiling: false, // 是否开启边录音边转化（后期改用web worker）
    }))

    recorder.onprogress = (params) => {
      // console.log('音频时长', params.duration.toFixed(5));
      // console.log('音频大小', params.fileSize);
      // console.log('音频音量', params.vol.toFixed(2));
      this.tip = '录音时长'
      this.playTimer && clearTimeout(this.playTimer)
      this.duration = formatTime(params.duration.toFixed(0))
    }
    const getPlayTime = () => {
      this.playTimer && clearTimeout(this.playTimer)
      this.playTimer = setTimeout(() => {
        this.duration = formatTime(recorder.getPlayTime())
        getPlayTime()
      }, 1000)
    }
    recorder.onplay = () => {
      this.tip = '播放时长'
      getPlayTime()
      console.log('%c回调监听，开始播放音频', 'color: #2196f3')
    }
    recorder.onpauseplay = () => {
      this.tip = '暂停播放'
      console.log('%c回调监听，暂停播放音频', 'color: #2196f3')
    }
    recorder.onresumeplay = () => {
      this.tip = '恢复播放'
      console.log('%c回调监听，恢复播放音频', 'color: #2196f3')
    }
    recorder.onstopplay = () => {
      this.tip = '停止播放'
      this.playTimer && clearTimeout(this.playTimer)
      console.log('%c回调监听，停止播放音频', 'color: #2196f3')
    }
    lamejs()
  },

  methods: {
    manualStart() {
      if (!this.manualRecord) {
        return
      }
      this.start()
    },
    // 开始录音
    start() {
      //firefox兼容测试
      this.$refs.comRecoder.focus()

      this.startRecord = true
      console.log(this.inputDeviceId)
      this.recorder.start(this.inputDeviceId)
      this.drawRecord()
      //限定之间自动结束
      this.timeoutId = setTimeout(() => {
        if (this.recorder) {
          this.end()
        }
      }, this.time * 1000)
    },
    // 结束录音
    end() {
      this.recorder.stop()
      this.startRecord = false
      this.stopDrawRecord()

      if (this.recorder) {
        const data = this.convertToMp3(this.recorder.getWAV())
        this.$emit('recordEnd', data)
      } else {
        console.log('请先录音')
      }
      clearTimeout(this.timeoutId)
    },

    convertToMp3(wavDataView) {
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView) // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128)
      // 获取左右通道数据
      const result = this.recorder.getChannelData()
      const buffer = []

      const leftData =
        result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2)
      const rightData =
        result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2)
      const remaining = leftData.length + (rightData ? rightData.length : 0)

      const maxSamples = 1152
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples)
        let right = null
        let mp3buf = null

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples)
          mp3buf = mp3enc.encodeBuffer(left, right)
        } else {
          mp3buf = mp3enc.encodeBuffer(left)
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf)
        }
      }

      const enc = mp3enc.flush()

      if (enc.length > 0) {
        buffer.push(enc)
      }

      return new Blob(buffer, { type: 'audio/mp3' })
    },
    drawRecord() {
      // 用requestAnimationFrame稳定60fps绘制
      this.drawRecordId = requestAnimationFrame(this.drawRecord)

      // 实时获取音频大小数据
      let dataArray = this.recorder.getRecordAnalyseData()
      this.points = exmples(dataArray, pointNum).map((item) => {
        return ((item - 128) / 128) * 100 + 12
      })
    },
    drawPlay() {
      // 用requestAnimationFrame稳定60fps绘制
      this.drawPlayId = requestAnimationFrame(this.drawPlay)

      // 实时获取音频大小数据
      let dataArray = this.recorder.getPlayAnalyseData()
      this.points = exmples(dataArray, pointNum).map((item) => ((item - 128) / 128) * 100 + 5)
    },
    stopDrawPlay() {
      this.drawPlayId && cancelAnimationFrame(this.drawPlayId)
      this.drawPlayId = null
    },
    stopDrawRecord() {
      this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
      this.drawRecordId = null
    },
    playRecord() {
      this.recorder && this.recorder.play()
      this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
      this.drawRecordId = null
      console.log('播放录音')
      this.recorder && this.drawPlay()
    },

    pauseRecord() {
      if (this.recorder) {
        this.recorder.pause()
        console.log('暂停录音')
        this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
        this.drawRecordId = null
      }
    },
    resumeRecord() {
      this.recorder && this.recorder.resume()
      console.log('恢复录音')
      this.drawRecord()
    },
    endRecord() {
      this.recorder && this.recorder.stop()
      console.log('结束录音')
      this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
      this.drawRecordId = null
    },
    pausePlay() {
      this.stopDrawPlay()
      this.recorder && this.recorder.pausePlay()
      console.log('暂停播放')
    },
    resumePlay() {
      this.recorder && this.recorder.resumePlay()
      console.log('恢复播放')
      this.drawPlay()
    },
    clearPlay() {
      if (this.drawRecordId) {
        cancelAnimationFrame(this.drawRecordId)
        this.drawRecordId = null
      }
      this.stopDrawPlay()
    },
    stopPlay() {
      this.clearPlay()
      this.recorder && this.recorder.stopPlay()
      console.log('停止播放')
      this.stopDrawPlay()
    },
    destroyRecord() {
      this.clearPlay()
      if (this.recorder) {
        this.recorder.destroy().then(() => {
          console.log('销毁实例')
          this.recorder = null
          this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
          this.stopDrawPlay()
        })
      }
    },
  },
  beforeDestroy() {
    if (this.recorder) {
      this.recorder.destroy().then(() => {
        console.log('销毁实例')
        this.recorder = null
        this.drawRecordId && cancelAnimationFrame(this.drawRecordId)
        this.stopDrawPlay()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.recorder {
  color: #696974;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  .wave {
    // border: 1px solid #333;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;
    cursor: pointer;
    li {
      background-color: #fc5a5a;
      width: 3px;
      margin: 0 1px;
    }
  }
  .tip {
    color: #2c2f46;
    font-size: 16px;
  }
  .microphone-img {
    width: 70px;
    height: 70px;
    margin-bottom: 12px;
  }
  .wave-con {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
